import { render, staticRenderFns } from "./ProductField.vue?vue&type=template&id=c5c7d848&scoped=true&"
import script from "./ProductField.vue?vue&type=script&lang=js&"
export * from "./ProductField.vue?vue&type=script&lang=js&"
import style0 from "./ProductField.vue?vue&type=style&index=0&id=c5c7d848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c7d848",
  null
  
)

export default component.exports